import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody } from 'ui/common/modal';
import { connectModal as reduxModal, hide as hideModal } from 'redux-modal';
import { compose, bindActionCreators } from 'redux';
import Button from 'ui/common/button';
export const MODAL_NAME = 'pathway-details-modal';

const pathModal = props => {
  const { show, handleHide, title, description, more } = props;

  return (
    <Modal size="lg" isOpen={show}>
      <ModalHeader toggle={handleHide} className="text-center">
        {title}
      </ModalHeader>
      <ModalBody>
        <p>{description}</p>
        <div className="mb-5 mt-4 mx-auto d-flex justify-content-center">
          {!!more && (
            <a className="mx-auto" href={more} rel="noopener noreferrer" target="_blank">
              <Button>Learn More</Button>
            </a>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    hideModal: bindActionCreators(hideModal, dispatch),
  };
}

const withConnect = connect(null, mapDispatchToProps);

export default compose(withConnect)(
  reduxModal({
    name: MODAL_NAME,
  })(pathModal)
);



// WEBPACK FOOTER //
// ./src/ui/pages/home/PathModal.js